export default {
  dynamics: '{{change}} rispetto al {{time_unit}} precedente',
};
